import React from 'react'
import Loader from "../../Simple/Loader";

function ActionButtons(props) {
  const {
    showChilds,
    toggleShowChildren,
    showChildHeader,
    toggleChildHeader,
    update,
    filters,
    cacheUpdating,
    updateStatsCache,
    onFileExport,
  } = props

  return (
      <>
        <div className={'btn mb-3 mr-2 px-3 ' + (!showChilds ? 'btn-outline' : 'btn-primary')}
             onClick={toggleShowChildren}
        >
          <i className="fas fa-eye"></i>
        </div>
        {
          showChilds &&
          <div className={'btn mb-3 px-3 mr-2 ' + (!showChildHeader ? 'btn-outline' : 'btn-primary')}
               onClick={toggleChildHeader}
          >
            <i className="fas fa-heading"></i>
          </div>
        }
        <div className={'btn mb-3 mr-2 px-3 btn-outline'}
             onClick={() => update(filters)}
        >
          <i className="fas fa-redo"></i>
        </div>
        {
          !cacheUpdating && <div className={'btn mb-3 px-3 mr-2 btn-outline'}
                                 onClick={() => updateStatsCache}
          >
            <i className="far fa-hdd"></i>
          </div>
        }
        {
          cacheUpdating &&
          <div className={'btn mb-3 px-3 mr-2 btn-outline loader-button'}>
            <div className="loader-wrapper">
              <Loader/>
            </div>
          </div>
        }
        <div className={'btn mb-3 px-3 btn-outline'} onClick={onFileExport}>
          <i className="fas fa-file-export"></i>
        </div>
      </>)
}

export default ActionButtons
